import { createFileRoute } from "@tanstack/react-router"
import { ContractTablePage } from "./-components/ContractTablePage"

export const Route = createFileRoute("/app/contracts/contracts/")({
  component: ContractTablePage,
})
